export const serverProps = window._props;

const { uiRuntimeVersion } = serverProps;

export const baseApiUrl = '/aps/2';

export const baseFWUrl = `${baseApiUrl}/ui/runtime/ux1framework`;

export const stylesPath = `${baseFWUrl}/styles`;

export const themePath = `${stylesPath}/theme`;

export const imagesPath = `${themePath}/lib/images`;

export const bootstrapCssUrl = serverProps.bootstrapCSSPath;

export const spriteStyleUrl = `${themePath}/lib/sprite/view/sprite.css?version=${uiRuntimeVersion}`;

export const spriteDefinitionsUrl = `${themePath}/lib/sprite/symbol/svg/sprite.symbol.svg?version=${uiRuntimeVersion}`;

export const spriteSheetUrl = `${themePath}/lib/sprite/view/svg/sprite.view.svg?version=${uiRuntimeVersion}`;

export const ux1FrameworkCssUrl = `${baseFWUrl}/core/dist/UX1Framework.css?${uiRuntimeVersion}`;
export const tc2VariablesCssUrl = `/webgate/static/skins/v3/ccp2/tc2/variables.css?apsUIRuntimeVersion=${uiRuntimeVersion}`;
export const tc2CustomCssUrl = `/webgate/static/skins/v3/ccp2/tc2/custom.css?apsUIRuntimeVersion=${uiRuntimeVersion}`;

export const defaultCssUrls = [
	`${stylesPath}/ui-kit/dist/UX1UIKit.css?${uiRuntimeVersion}`,
	`${themePath}/lib/index.css?${uiRuntimeVersion}`
];

export const tc2CssUrls = [tc2VariablesCssUrl, tc2CustomCssUrl];

export const logosPath = '/webgate/static/skins/v3/images/logos/';

export const dashboardNavigationIds = [
	'http://www.parallels.com/ccp-dashboard#ux1-dashboard',
	'http://www.parallels.com/ccp-dashboard#dashboard'
];

// css font-family names for custom fonts in custom skins
export const customTextFonts = {
	regular: 'DefaultTextsFontRegular',
	bold: 'DefaultTextsFontBold'
};

export const ux1FrameworkDefaultColorsVariablesCssSelector = '.ux1-framework-default-colors-variables';
